export default {
  id: 'AddComponent',
  code: 'CN',
  text: {
  
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Website/AddComponent/locale.js